// App Config single-select for the scenario-generation engine (data_type='select').
// Backend reads it live per request (scenarioGenerationWorkflow.resolveScenarioEngine).
export const SCENARIO_ENGINE_KEY = 'feature/scenario_generation_workflow';

export type ScenarioEngineValue = 'legacy' | 'v2_dbr_batch' | 'v2_aws_batch';

// Options shown in the App Config single-select (Control Tower).
export const SCENARIO_ENGINE_OPTIONS: { value: ScenarioEngineValue; label: string }[] = [
  { value: 'legacy', label: 'Legacy' },
  { value: 'v2_dbr_batch', label: 'V2 Databricks Batch' },
  { value: 'v2_aws_batch', label: 'V2 AWS Batch' },
];

// Default when the row is absent/blank: the current batch-on behaviour.
export const SCENARIO_ENGINE_DEFAULT: ScenarioEngineValue = 'v2_dbr_batch';

// Bulk refresh runs through the batch flow, which only the v2 engines support. Legacy
// (per-scenario DBR job) can't safely run a batch, so bulk is gated off for it.
export const isV2ScenarioEngine = (value: string | null | undefined): boolean =>
  value === 'v2_dbr_batch' || value === 'v2_aws_batch';

// App Config single-select for the v2_aws_batch source cache (data_type='select'). Read live by the
// engine (run.py::cache_mode). Default 'off' (disabled); only effective where the cache is deployed.
export const SCENARIO_CACHE_KEY = 'feature/scenario_cache';

export type ScenarioCacheValue = 'off' | 'on' | 'force';

export const SCENARIO_CACHE_OPTIONS: { value: ScenarioCacheValue; label: string }[] = [
  { value: 'off', label: 'Off (disabled)' },
  { value: 'on', label: 'On' },
  { value: 'force', label: 'Force rebuild' },
];
